export default {
  '内容形式':'内容形式',
  '发布时间':'發佈時間',
  '请输入标题搜索':'請輸入標題搜索',
  '封面图':'封面圖',
  '备课内容':'備課内容',
  '备课视频':'備課視頻',
  '发布设置':'發佈設置',
  '支持jpg':'支持jpg/jpeg/png格式，建議比例為4:3，最大不超過5M',
  '请上传封面图':'請上傳封面圖',
  '请上传备课视频':'請上傳備課視頻',
  '支持上传mp4格式':'支持上傳mp4格式，且視頻小於500M。',
  '链接地址':'鏈接地址',
  '视频描述':'視頻描述',
  '标题不可为空':'標題不可爲空',
  '内容不可为空':'內容不可為空',
  '确认要停用':'確認要停用',
  '本机构资源空间已不足，请及时联系运营人员':'本机构資源空間已不足，請及时聯繫運營人員',
}